(function () {
  'use strict';

  const angular = window.angular;

  varConfigs.$inject = ['$uibModal', '$state', 'LoopBackAuth', 'AppUtils', '$rootScope'];

  angular.module('app').component('varConfigs', {
    template:'<h2 class="text-info marginT0">Tool Kit Templates</h2><div class="panel panel-default"><header class="panel-heading"><h2 class="nowrap"></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><button class="btn btn-primary" ng-click="ctrl.showLinkToolkitTemplateModal()"><i class="fas fa-link"></i></button></div></div></header><div class="panel-body no-padding"><toolkit-template-table toolkit-templates="ctrl.toolkitTemplatesFiltered" tools="ctrl.tools"></toolkit-template-table></div></div><hr class="marginT0"><h2 class="text-info marginT0" translate>entities.user.modelNamePl</h2><div class="panel panel-default"><header class="panel-heading"><h2 class="nowrap"><strong translate>entities.user.supportAdmin.modelNamePl</strong></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><button class="btn btn-primary" ng-click="ctrl.showLinkUserModal()"><i class="fas fa-link"></i></button></div></div></header><div class="panel-body no-padding"><users-table users="ctrl.supportAdminsFiltered" time-zones="undefined" countries="undefined" user-type="\'SupportAdmin\'" unlink="true" vars="ctrl.vars"></users-table></div></div><div class="panel panel-default"><header class="panel-heading"><h2 class="nowrap"><strong translate>entities.organization.members</strong></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><button class="btn btn-primary" ng-click="ctrl.showCreateUserModal()"><i class="fas fa-plus"></i></button></div></div></header><div class="panel-body no-padding"><users-table users="ctrl.organization.admins" edit="true" remove="true" user-type="\'Admin\'" time-zones="ctrl.timeZones" countries="ctrl.countries"></users-table></div></div>',
    controller: varConfigs,
    controllerAs: 'ctrl',
    bindings: {
      supportAdmins: '<',
      countries: '<',
      timeZones: '<',
      organization: '<',
      users: '<',
      vars: '<',
      toolkitTemplates: '<',
      tools: '<',
    },
  });

  function varConfigs($uibModal, $state, LoopBackAuth, utils, $root) {
    let vm = this;

    vm.$onInit = function () {
      vm.varId = $root.varId;
      vm.var = vm.vars.find((e) => e.id === vm.varId);
      vm.toolkitTemplatesFiltered = vm.toolkitTemplates.filter((toolkitTemplate) =>
        vm.var.toolkitTemplateIds.includes(toolkitTemplate.id)
      );

      vm.toolkitTemplatesNotSelected = vm.toolkitTemplates.filter(
        (toolkitTemplate) => !vm.var.toolkitTemplateIds.includes(toolkitTemplate.id)
      );
      vm.showCreateUserModal = showCreateUserModal;
      vm.showLinkUserModal = showLinkUserModal;
      vm.showLinkToolkitTemplateModal = showLinkToolkitTemplateModal;
      vm.varId = $root.varId;
      vm.currentUser = $root.user;
      vm.supportAdminsFiltered = vm.supportAdmins.filter(
        (supportAdmin) =>
          supportAdmin.id !== vm.currentUser.id &&
          (supportAdmin.vars || []).some((v) => v.id === $root.varId)
      );
    };
    function showCreateUserModal() {
      let instance = $uibModal.open({
        animation: false,
        backdrop: 'static',
        bindToController: true,
        component: 'adminForm',
        size: 'lg',
        resolve: {
          vars: function () {
            return vm.vars;
          },
          user: function () {
            return {};
          },
          countries: function () {
            return vm.countries;
          },
          timezones: function () {
            return vm.timeZones;
          },
          organizationId: function () {
            return vm.organization.id;
          },
        },
      });

      instance.result
        .then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showLinkUserModal() {
      let instance = $uibModal.open({
        animation: false,
        backdrop: 'static',
        bindToController: true,
        component: 'supportAdminLinkModal',
        resolve: {
          varId: function () {
            return vm.varId;
          },
          users: function () {
            return vm.supportAdmins;
          },
        },
      });

      instance.result
        .then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showLinkToolkitTemplateModal() {
      let instance = $uibModal.open({
        animation: false,
        backdrop: 'static',
        bindToController: true,
        component: 'toolKitTemplateLinkModal',
        resolve: {
          var: function () {
            return vm.var;
          },
          toolKitTemplates: function () {
            return vm.toolkitTemplates;
          },
          tools: function () {
            return vm.tools;
          },
        },
      });

      instance.result
        .then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }
})();
